document.addEventListener('DOMContentLoaded', (event) => {
    setTimeout(() => {
      let element1 = document.querySelector('.subify-max-discount-badge-percentage');
      let element2 = document.querySelector('.discount-value');
      let poweredTextElement = document.querySelector('.subify-powered-text');
      
      if (element1 && element2) {
        element1.textContent = '20%';
        element2.textContent = '20';
      }

      if (poweredTextElement) {
        poweredTextElement.style.cssText = ''; 
        poweredTextElement.style.setProperty('display', 'none', 'important');
      }
    }, 900);
  });